/* ---------------------------------------------------------------
   Vitals Product Reviews — wrapper injector
   ---------------------------------------------------------------
   Vitals injects its widget at runtime via an app block, so we
   can't add a wrapper in Liquid. This script watches for the
   widget to appear, then wraps it in a .hvac-vitals-wrap element
   with a custom header ("Customer Reviews / Verified Purchases
   Only") that our CSS restyles.

   If Vitals renames its class/id, update WIDGET_SELECTORS below.
   --------------------------------------------------------------- */
(function () {
  'use strict';

  var WIDGET_SELECTORS = [
    '[data-vitals-widget="product-reviews"]',
    '.vtl-product-reviews',
    '.vtl-widget-reviews',
    '#vitals-product-reviews-app',
    '[id*="vitals-product-reviews"]',
    '[class*="vtl-product-reviews"]'
  ];

  var HEADER_HTML =
    '<div class="hvac-vitals-wrap__header">' +
      '<div>' +
        '<h2 class="hvac-vitals-wrap__title">Customer Reviews</h2>' +
        '<p class="hvac-vitals-wrap__subtitle">Real feedback from verified HVAC buyers</p>' +
      '</div>' +
      '<div class="hvac-vitals-wrap__badge">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>' +
          '<polyline points="9 12 11 14 15 10"/>' +
        '</svg>' +
        '<span>Verified Purchases Only</span>' +
      '</div>' +
    '</div>';

  function findWidget() {
    for (var i = 0; i < WIDGET_SELECTORS.length; i++) {
      var el = document.querySelector(WIDGET_SELECTORS[i]);
      if (el) return el;
    }
    return null;
  }

  function wrap(widget) {
    if (widget.closest('.hvac-vitals-wrap')) return true;
    var wrapper = document.createElement('div');
    wrapper.className = 'hvac-vitals-wrap';
    wrapper.innerHTML = HEADER_HTML;
    widget.parentNode.insertBefore(wrapper, widget);
    wrapper.appendChild(widget);
    return true;
  }

  function tryWrap() {
    var widget = findWidget();
    if (widget) return wrap(widget);
    return false;
  }

  if (tryWrap()) return;

  // Widget not in DOM yet — Vitals injects asynchronously. Watch
  // for it, stop watching once wrapped or after a 20s safety cap.
  var observer = new MutationObserver(function () {
    if (tryWrap()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 20000);
})();
